import { createRoot } from 'react-dom/client';
import '@/app/i18n.ts';
import '@/assets/common/css/fonts.css';
import '@/index.css';
import App from '@/app/App';
import { ModalProvider } from '@/shared/components/ModalProvider.tsx';
import { StrictMode } from 'react';
import ThemeProvider from './app/ThemeProvider';

/**
 * 페이지를 초기화합니다.
 * @returns 없음
 * @author Olive
 */
const container = document.getElementById('root') as HTMLElement;

const root = createRoot(container);
root.render(
  <StrictMode>
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <ModalProvider>
        <App />
      </ModalProvider>
    </ThemeProvider>
  </StrictMode>,
);
